import OptOutListingPage from "src/components/aioptout/optout-listing/optoutlistingpage";

const OptOutList = () => {
  return <OptOutListingPage />;
};

export default OptOutList;
